import { motion } from "framer-motion";
import { WhatsAppIcon } from "./Logo";
import { WHATSAPP_URL } from "../constants";

export const FloatingWhatsApp = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-floating-button"
    aria-label="Scrivici su WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.2, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_32px_rgba(37,211,102,0.4)]"
  >
    <WhatsAppIcon className="w-7 h-7 md:w-8 md:h-8" />
  </motion.a>
);
